import { HashLink } from 'react-router-hash-link';
import { isRelease261Enabled } from '@/config/release261Features';

type ReferencesProps = {
  showHeading?: boolean;
};

function References({ showHeading = true }: ReferencesProps) {
  return (
    <div id="section45">
      {showHeading && <h3>References</h3>}
      <ul>
        <li className="bullet-item">Reference year</li>
        <li className="bullet-item">Journal</li>
        <li className="bullet-item">Reference: the identifier of the reference (PMID or NCTID)</li>
        <li className="bullet-item">Reference type: publication (PMID) or clinical trial (NCTID)</li>
        {isRelease261Enabled && (
          <li className="bullet-item">
            <HashLink smooth to="/docs?section=metrics&subsection=normalizedScore" className="js-fix-scroll">
              Normalized Score
            </HashLink>
            : rescales the original DISGENET score to a standard 0–1 range while preserving relative
            differences between associations.
          </li>
        )}
        <li className="bullet-item">
          Citation counts: number of citations per article obtained from{' '}
          <a href="https://icite.od.nih.gov/" target="_blank" rel="noopener noreferrer">
            iCite
          </a>
          . Each entry links to the corresponding citing articles via a single URL.
        </li>
        <li className="bullet-item">
          Translation: is the 
          <a
            href="https://support.icite.nih.gov/hc/en-us/articles/9349049758875-Approximate-Potential-to-Translate-APT"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Approximate Potential to Translate{' '}
          </a>
            that identifies early signals of “bench-to-bedside” translation based on how the scientific
          community engages with and cites the work.
        </li>
      </ul>
    </div>
  );
}
export default References;
